import { Injectable } from '@angular/core';
import { format,parse,differenceInSeconds } from 'date-fns';
import { from,Observable,of,Subject,BehaviorSubject } from 'rxjs';

import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
    ,dtgCarTypeList
    ,DtgDriveScheduleRow
    ,DtgDriveScheduleItem
    ,DtgDriveScheduleItemDrive
    ,DtgDriveScheduleItemRest
} from "src/app/shared/vo";

@Injectable({providedIn: 'root'})
export class FvmsDtgCarDriveHisService {
    private schemaName:string = "dtg";
    private idb:IDBDatabase;
    private tbNameMainCarDriveHisData:string = "main_car_drive_his_data";
    public subjectListHis:BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);

    constructor(
        
    ) {

    }

    checkIndexDbSupport(){
        if(!('indexedDB' in window)) {
            console.log('This browser doesn\'t support IndexedDB');
            return false;
        }else{
            console.log('This browser support IndexedDB');
            return true;
        }
    }

    initDb(){
        let promise = new Promise((resolve,reject) => {
            let idbFactory = indexedDB;
            let dbPromise = idbFactory.open(this.schemaName,1);
            dbPromise.onerror = (err:any) => {
                console.error("db open err",err);
                reject(err);
            };
            // 호출순서:1
            dbPromise.onupgradeneeded = (evt:any) => {
                // console.log("onupgradeneeded",evt.target.result);
                this.idb = evt.target.result;
                let tx:IDBTransaction = evt.target.transaction;

                if(this.idb.objectStoreNames.contains(this.tbNameMainCarDriveHisData)){
                    this.idb.deleteObjectStore(this.tbNameMainCarDriveHisData);
                }

                let dbOptMainCarDriveHisData:IDBObjectStoreParameters = {
                    keyPath:"id"
                    ,autoIncrement:true
                };
                let tbMainCarDriveHisData = this.idb.createObjectStore(this.tbNameMainCarDriveHisData,dbOptMainCarDriveHisData);
                tbMainCarDriveHisData.createIndex(`idx_${this.tbNameMainCarDriveHisData}_01`,["dtgUnitId","dtgRegDt"],{unique:true});
                tbMainCarDriveHisData.createIndex(`idx_${this.tbNameMainCarDriveHisData}_fvmsTripCnt`,"fvmsTripCnt",{unique:false});

                useDb(this.idb);
                tx.oncomplete = function(evtTx){
                    resolve(evt.target.result);
                }
            };
            // 호출순서:2
            dbPromise.onsuccess = (evt:any) => {
                // console.log("onsuccess",evt.target.result);
                this.idb = evt.target.result;
                useDb(this.idb);
                resolve(this.idb);
            };

            function useDb(idb){
                idb.onversionchange = function(event) {
                    idb.close();
                    console.log("A new version of this page is ready. Please reload or close this tab!");
                };
            }
        });
        return promise;
    }

    addListHisData(listItem:any[]){
        let promise = new Promise(async (resolve,reject) => {
            let tx:IDBTransaction = this.idb.transaction([this.tbNameMainCarDriveHisData],"readwrite");
            let tbMainCarDriveHisData = tx.objectStore(this.tbNameMainCarDriveHisData);
            tbMainCarDriveHisData.clear();
            if(listItem){
                let sizeListItem = listItem.length;
                for(let a=0;a<sizeListItem;a++){
                    let item = listItem[a];
                    tbMainCarDriveHisData.add(item);
                }
                resolve(listItem);
            }
            tx.onerror = (err) => {
                reject(listItem);
            };
        });
        return promise;
    }
}